export enum WalletType {
  METAMASK = 'MetaMask',
  COINBASE_WALLET = 'Coinbase Wallet',
  WALLET_CONNECT = 'WalletConnect',
  DISCONNECTED = 'Disconneted',
}
